import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedDeliveryShippings: [],
};

const deliveryShippingSlice = createSlice({
	name: 'deliveryShippings',
	initialState: initialState,
	reducers: {
		setDeliveryShippings: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setDeliveryShippings, reset } = deliveryShippingSlice.actions;

export default deliveryShippingSlice.reducer;